import type { ReactNode } from "react";
import { useUserPermissions } from "@src/presentation/hooks/permissions";

interface HasAppPermissionProps {
  children: ReactNode;
  requiredPermissions: string[];
}

const HasAnyPermission = ({
  children,
  requiredPermissions,
}: Readonly<HasAppPermissionProps>) => {
  const { hasAnyPermission } = useUserPermissions();

  if (!hasAnyPermission(requiredPermissions)) {
    return null;
  }

  return children;
};

export default HasAnyPermission;
